import { APP_CONFIG } from "@/config"
import { FAQs } from "@/modules/infoAndService/components/FAQs"
import { Info } from "@/modules/infoAndService/components/Info"
import { StaticPage } from "@/modules/infoAndService/components/StaticPage"
import { Container, Grid, MantineTheme, Text, createStyles } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import { useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import { FC, useEffect, useState } from "react"

const useStyles = createStyles((theme: MantineTheme) => ({}))

const RedirectOnMount = ({ url }: { url: string }) => {
  const { push } = useRouter()
  useEffect(() => {
    push(url)
  }, [])

  return null
}

export const InfoAndQuestion: FC = () => {
  const { classes } = useStyles()

  const { locale } = useRouter()
  const { t } = useTranslation("common")

  const list = [
    { title: t("FAQs", "FAQs"), component: <FAQs /> },

    {
      title: t("Privacy", "Privacy"),
      component: <StaticPage pageId={APP_CONFIG.STATIC_PAGES.PRIVACY.find(e => e.locale === locale)!.pageId} />,
    },
    {
      title: t("Contact", "Contact"),
      component: <RedirectOnMount url="/contact" />,
    },
  ]

  const [active, setActive] = useState<string>(list[0].title)
  const isResponsive = useMediaQuery("(max-width: 48em )")

  const activePage = list.find(e => e.title === active) ?? list[0]

  return (
    <Container p={0} m={0} fluid mt={69}>
      <Grid
        p={0}
        m={0}
        columns={24}
        sx={theme => ({
          [theme.fn.smallerThan("sm")]: {
            gap: "2rem",
          },
        })}
      >
        <Grid.Col span={24} p={0} m={0} sm={7}>
          <Text fz={isResponsive ? 14 : 20} fw={700} pl={isResponsive ? 0 : 21} mb={21}>
            {t("Information & Employment", "Information & Employment")}
          </Text>
          <Info
            list={list}
            activePage={active}
            onChange={title => {
              setActive(title)
            }}
          />
        </Grid.Col>
        <Grid.Col span={24} p={0} m={0} pl={isResponsive ? 10 : 40} sm={17}>
          <Text fz={isResponsive ? 14 : 20} fw={700} mb={21}>
            {activePage.title}
          </Text>
          {activePage.component}
        </Grid.Col>
      </Grid>
    </Container>
  )
}
